"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aphrodite = void 0;
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Aphrodite = (function (_super) {
    __extends(Aphrodite, _super);
    function Aphrodite() {
        return _super.call(this, {
            name: CardName_1.CardName.APHRODITE,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.VENUS],
            startingMegaCredits: 47,
            cardType: CardType_1.CardType.CORPORATION,
            metadata: {
                cardNumber: 'R01',
                description: 'You start with 1 plant production and 47 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.production(function (pb) { return pb.plants(1); }).nbsp.megacredits(47);
                    b.corpBox('effect', function (ce) {
                        ce.effect('Whenever Venus is terraformed 1 step, you gain 2 M€.', function (eb) {
                            eb.venus(1).any.startEffect.megacredits(2);
                        });
                    });
                }),
            },
        }) || this;
    }
    Aphrodite.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        return undefined;
    };
    return Aphrodite;
}(Card_1.Card));
exports.Aphrodite = Aphrodite;
//# sourceMappingURL=Aphrodite.js.map